import React from 'react';
import { Form, Button, Input, Col, Row, InputNumber, message } from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { postFrom, config } from '../../../../axios';
import moment from 'moment'
import { ReceivablesType, dicPayChannel, dicPayType, dicTradeRecordStatus, liuShuiMeiJu } from '../../../../axios/dictionaries';
import ActionRecords from '../../../ActionRecords/index';
import { moneyAddComma } from '../../../../utils/index'

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            InputWidth: "185px",
            shortInputWidth: "154px",
            actionVisible: false,
            data: {},
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadPackage = (id) => {
        this.setState({ loading: true });
        let data = { billId: id };
        postFrom({ url: config.API_bill_getBillById, data }).then(res => {
            res.receiveTradeRecordlist = res.receiveTradeRecordlist.map(item => {
                item.payChannel = dicPayChannel.find(item1 => item1.value === item.payChannel);
                item.payType = dicPayType.find(item1 => item1.value === item.payType);
                item.tradeStatus = liuShuiMeiJu.find(item1 => item1.value === item.tradeStatus);
                return item
            });
            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
        })
    }


    render() {
        let { visible, handleCancel, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data,
            actionVisible,
        } = this.state;
        let billstate = data.historyBill ? { title: '历史迁移' } : ReceivablesType.find(item => item.value === data.receiveStatus);

        return <ModalDom
            title="收款详情 【账单】"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={handleCancel}
            footer={
                <div>
                    {/* <Button type="primary" loading={loading}>打印</Button> */}
                    <Button onClick={handleCancel}>关闭</Button>
                </div>
            }
            actionRecords={true}
            handleAction={() => {
                this.setState({ actionVisible: true });
                this.onAction.queryActionRecords({ rowId: data.id, tableName: "bill" });
            }}
        >
            <ActionRecords
                onRef={ref => this.onAction = ref}
                visible={actionVisible}
                handleCancel={() => { this.setState({ actionVisible: false }) }}
            />

            <div className="custom">
                <Form labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}>
                    <Row>
                        <Col>
                            <DetailTitle title="房源" boxStyle={{ marginTop: 0 }} />
                            <CustomRow>
                                <CustomCol label="楼栋/楼盘" required={false} >
                                    {getFieldDecorator('buildingName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.buildingName
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="房间号" required={false} >
                                    {getFieldDecorator('roomNo', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.roomNo
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        <Col>
                            <DetailTitle title="租客" />
                            <CustomRow>
                                <CustomCol label="姓名" required={false} >
                                    {getFieldDecorator('customerName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.customerName
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="证件号码" required={false} >
                                    {getFieldDecorator('credentialNumber', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.credentialNumber
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="手机号码" required={false} >
                                    {getFieldDecorator('customerPhone', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.customerPhone
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        <Col>
                            <DetailTitle title="账单" />
                            <CustomRow>
                                <CustomCol label="账单名称" required={false} >
                                    {getFieldDecorator('feeName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.feeName
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="应收日期" required={false} >
                                    {getFieldDecorator('mustPayDate', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.mustPayDate ? moment(data.mustPayDate).format('YYYY-MM-DD') : null
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="应收金额" required={false} subfix={<div style={{ background: "#f0f2f5" }}>元</div>} >
                                    {getFieldDecorator('billMoney', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.billMoney
                                    })(
                                        <InputNumber
                                            style={{ disabled: { color: "red" } }}
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                    <CustomCol label="水电起数" required={false} >
                                    {getFieldDecorator('beginNum', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.beginNum!=null?data.beginNum:'-'
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="水电止数" required={false} >
                                    {getFieldDecorator('endNum', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.endNum!=null?data.endNum:'-'
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="水电单价" required={false} >
                                    {getFieldDecorator('unitPrice', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.unitPrice!=null? data.unitPrice:'-'
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="账单周期" required={false} >
                                    {getFieldDecorator('faceDetected', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.billBeginDate && data.billEndDate ? moment(data.billBeginDate).format('YYYY-MM-DD') + " 至 " + moment(data.billEndDate).format('YYYY-MM-DD') : null
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="账单说明" required={false} colStyle={{ width: "501px" }} >
                                    {getFieldDecorator('feeRemark', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.feeRemark
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="账单状态" required={false} >
                                    {getFieldDecorator('receiveStatus', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: billstate ? billstate.title : ""
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="结清日期" required={false} >
                                    {getFieldDecorator('finishDate', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.finishDate ? moment(data.finishDate).format('YYYY-MM-DD') : undefined
                                    })(
                                        <Input
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        <Col>
                            <div>
                                <DetailTitle title="收款" />
                                <div className="tableBox">
                                    <div className="tableTitle">
                                        <div style={{ flex: 1 }}>交易日期</div>
                                        <div style={{ flex: 1 }}>他方流水</div>
                                        <div style={{ flex: 1 }}>交易金额（元）</div>
                                        <div style={{ flex: 1 }}>交易渠道</div>
                                        <div style={{ flex: 1 }}>交易方式</div>
                                        <div style={{ flex: 1 }}>交易状态</div>
                                        <div style={{ flex: 1 }}>核销日期</div>
                                        <div style={{ flex: 1 }}>核销金额（元）</div>
                                        <div style={{ flex: 1 }}>优惠金额（元）</div>
                                    </div>

                                    <div className="tableBody">
                                        {
                                            data.receiveTradeRecordlist instanceof Array && data.receiveTradeRecordlist.length > 0 ?
                                                data.receiveTradeRecordlist.map((item, index) => {
                                                    return (
                                                        <div className="tableBodyRow" key={index}>
                                                            <div style={{ flex: 1 }}>{item.tradeTime ? moment(item.tradeTime).format('YYYY-MM-DD') : null}</div>
                                                            <div style={{ flex: 1 }}>{item.orderNoThird}</div>
                                                            <div style={{ flex: 1 }}>{moneyAddComma(item.tradeRecordAmount)}</div>
                                                            <div style={{ flex: 1 }}>{item.payChannel ? item.payChannel.title : ''}</div>
                                                            <div style={{ flex: 1 }}>{item.payType ? item.payType.title : ''}</div>
                                                            <div style={{ flex: 1 }}>{item.tradeStatus ? item.tradeStatus.title : ''}</div>
                                                            <div style={{ flex: 1 }}>{item.payLogCreateTime ? moment(item.payLogCreateTime).format('YYYY-MM-DD') : null}</div>
                                                            <div style={{ flex: 1 }}>{moneyAddComma(item.payLogAmount-(item.creditAmount==null?0:item.creditAmount))}</div>
                                                            <div style={{ flex: 1 }}>{moneyAddComma(item.creditAmount)}</div>
                                                        </div>
                                                    )
                                                })
                                                : <div className="tableBodyRow" style={{ justifyContent: 'center', lineHeight: '34px' }}>
                                                    暂无数据！
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Form>


                {/* <Col>
                        <DetailTitle title="记录" />
                        <div className="tableBox" style={{ margin: '0 20px' }}>
                            <div className="tableTitle">
                                <div style={{ flex: 1 }}>操作时间</div>
                                <div style={{ flex: 1 }}>操作名称</div>
                                <div style={{ flex: 1 }}>部门</div>
                                <div style={{ flex: 1 }}>人员</div>
                            </div>
                            <div className="tableBody">
                                <div className="tableBodyRow">
                                    <div style={{ flex: 1 }}></div>
                                    <div style={{ flex: 1 }}>1231</div>
                                    <div style={{ flex: 1 }}>2,000.00</div>
                                    <div style={{ flex: 1 }}>微信</div>
                                </div>
                            </div>
                        </div>
                        </Col> */}
                {/* 
                    另一个状态的表格
                    <div className="tableBox" style={{ margin: '0 20px' }}>
                        <div className="tableTitle">
                            <div style={{ flex: 1 }}>支付日期</div>
                            <div style={{ flex: 1 }}>交易金额（元）</div>
                            <div style={{ flex: 1 }}>交易渠道</div>
                            <div style={{ flex: 1 }}>交易渠道</div>
                            <div style={{ flex: 1 }}>交易方式</div>
                            <div style={{ flex: 1 }}>交易状态</div>
                        </div>
                        <div className="tableBody">
                            <div className="tableBodyRow">
                                <div style={{ flex: 1 }}>1231</div>
                                <div style={{ flex: 1 }}>合同编号</div>
                                <div style={{ flex: 1 }}>合同编号</div>
                                <div style={{ flex: 1 }}>合同名称</div>
                                <div style={{ flex: 1 }}>操作</div>
                            </div>
                        </div>
                    </div>
                 */}
            </div>
        </ModalDom>
    }


}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Bill/components/Receiv/Detail.js